export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
    calendlyUrl: "https://calendly.com/fp-legacy-insurance/llamada",
    phoneDisplay: "+1 (786) 389-0628",
    phoneHref: "tel:+17863890628",
    whatsappUrl:
        "https://wa.me/17863890628?text=Hola%20Fabiana%2C%20quisiera%20agendar%20una%20llamada%20sobre%20mi%20estrategia%20IUL.",
    email: "fpadron.insurance@gmail.com",
    emailHref: "mailto:fpadron.insurance@gmail.com",
};

export const IMAGES = {
    fabiana: "/images/fabiana.webp",
    forest: "/images/familia.webp",
    ctaBg:
        "https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?auto=format&fit=crop&w=1800&q=80",
};

export const CARRIERS = [
    { name: "F&G Annuities & Life", slug: "fg", src: "/images/logos/fg.webp", tall: true },
    { name: "Mutual of Omaha", slug: "mutual-of-omaha", src: "/images/logos/mutual-of-omaha.webp" },
    { name: "Americo", slug: "americo", src: "/images/logos/americo.webp" },
    { name: "National Life Group", slug: "national-life", src: "/images/logos/national-life.webp" },
];

export const CREDENTIALS = [
    {
        title: "Acceso a las compañías de Seguro más grandes de USA",
        detail:
            "Americo · Mutual of Omaha · Fidelity & Guaranty · Transamerica · National Life Group · American Amicable",
    },
    {
        title: "Estados licenciados",
        detail: "California · Texas · Colorado · Illinois · Florida · Virginia",
    },
    {
        title: "Verificación de licencia",
        detail:
            "Podrás verificar mi licencia en nipr.com y en el departamento de seguros de tu estado.",
    },
];
